// client/src/pages/Manifesto.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';

const manifestoItems = [
  {
    title: '1. Preserving Individual Store Ownership',
    content: `Better Turns is built on the principle that every store remains independently owned. Local autonomy and community engagement come first.

**Safeguards:**
- 🚫 No Forced Consolidation  
- 🛍️ Full Member Autonomy  
- 🗳️ Governance Clause: Supermajority required for any changes to ownership rights.`,
  },
  {
    title: '2. Equitable Policy Implementation',
    content: `Growth shouldn't mean inequality. Our policies must benefit all members, not just a few.

**Safeguards:**
- ⚖️ Uniform Policy Application  
- 📖 Transparent Documentation  
- 🧭 Oversight Committee to review major proposals`,
  },
  {
    title: '3. Ensuring Fair Competition Among Members',
    content: `Healthy co-op relationships rely on fair play and trust — not favoritism.

**Safeguards:**
- 🚫 No Internal Favoritism  
- 🔐 Data Privacy Standards  
- 🧾 Grievance Process and independent review panel`,
  },
  {
    title: '4. Preventing Power Consolidation',
    content: `To avoid centralization of control, we believe in shared leadership and rotating governance.

**Safeguards:**
- 🔁 Leadership Term Limits  
- 🧩 Distributed Governance Structure  
- 🗳️ Leadership Elections Required`,
  },
  {
    title: '5. Profit Redistribution and Reinvestment',
    content: `Profits should power communities — not just central HQs.

**Safeguards:**
- 💸 Profit Sharing based on contribution  
- 🌱 Community Investment programs  
- 🔐 Governance Clause for any model changes`,
  },
  {
    title: '6. Mission Lock and Ethical Charter',
    content: `Our founding mission must endure, even as we scale.

**Safeguards:**
- 🛡️ Mission Lock Clause  
- 📜 Ethical Charter rooted in fairness and transparency  
- 🗳️ Supermajority required to amend mission or ethics`,
  },
];

const Manifesto = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="section-wrapper bg-white px-6 py-12 md:px-20 text-deep-navy">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-primary mb-8 text-center">
          The BetterTurns Manifesto
        </h2>

        <div className="space-y-6">
          {manifestoItems.map((item, index) => (
            <div
              key={index}
              className="border border-cool-gray rounded-lg"
            >
              <button
                onClick={() => toggleItem(index)}
                className="w-full text-left px-4 py-3 flex justify-between items-center bg-soft-earth hover:bg-mint-green transition-colors"
              >
                <span className="font-semibold text-lg">{item.title}</span>
                {openIndex === index ? (
                  <HiChevronUp className="text-xl text-primary" />
                ) : (
                  <HiChevronDown className="text-xl text-primary" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-4 py-3 whitespace-pre-wrap text-gray-800 text-base leading-relaxed">
                  <React.Fragment>
                    {item.content.split('\n').map((line, i) => (
                      <p
                        key={i}
                        className="mb-2"
                      >
                        {line}
                      </p>
                    ))}
                  </React.Fragment>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/"
            className="text-sunshine-yellow font-semibold hover:text-warm-orange"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
